// extracted by mini-css-extract-plugin
module.exports = {"container":"SidebarOpenButtonPeriodOpen_container__1Mx4A","icon-update":"SidebarOpenButtonPeriodOpen_icon-update__1CPVj"};